import { createFileRoute } from '@tanstack/react-router';
import { JourneyEditorPage } from '@web/modules/campaigns/journeys/journey-editor-page';

export const Route = createFileRoute('/_app/campaigns/journeys/$journeyId')({
  component: JourneyRoute,
});

function JourneyRoute() {
  const { journeyId } = Route.useParams();
  return <JourneyEditorPage journeyId={journeyId} />;
}
